module.exports = __webpack_public_path__ + "note.png?2d75a1e1a54ecde736535cecca1d7492";